module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "moileParticulars"
  }, [_c('van-nav-bar', {
    attrs: {
      "title": "我的培训班",
      "fixed": "",
      "left-text": "返回",
      "left-arrow": ""
    },
    on: {
      "click-left": function($event) {
        return _vm.$router.back(-1)
      }
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.refreshing),
      callback: function($$v) {
        _vm.refreshing = $$v
      },
      expression: "refreshing"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": ""
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(goods) {
    return _c('div', {
      key: goods.id,
      attrs: {
        "title": goods.id
      }
    }, [_c('div', {
      staticStyle: {
        "position": "relative",
        "background": "left top no-repeat",
        "background-size": "100% 100%"
      }
    }, [_c('img', {
      staticClass: "previewImg",
      attrs: {
        "src": goods.goodsPic
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "particularsTitle cb"
    }, [_c('h4', {
      staticClass: "videoTitle fl"
    }, [_vm._v(_vm._s(goods.goodsName))]), _vm._v(" "), _c('span', {
      staticClass: "time fr"
    }, [_vm._v("进度:" + _vm._s(_vm.formatPer(goods.studyPercent)))])]), _vm._v(" "), _c('div', {
      staticClass: "particularsTitle2 cb",
      staticStyle: {
        "padding": "0 0.2rem"
      }
    }, [_c('h4', {
      staticClass: "videoTitle fl"
    }, [_vm._v("学习时间:" + _vm._s(_vm.formatDate(goods.studyStartTime)) + " ~ " + _vm._s(_vm.formatDate(goods.studyEndTime)))]), _vm._v(" "), _c('span', {
      staticClass: "time fr",
      staticStyle: {
        "color": "#222",
        "line-height": "0.78rem"
      }
    }, [_vm._v("学时：" + _vm._s(goods.testHours) + "课时")])]), _vm._v(" "), _c('div', {
      staticClass: "particularsTitle2 cb"
    }, [_c('van-button', {
      attrs: {
        "to": {
          path: 'mobileClassDetail',
          query: {
            'id': goods.goodsId
          }
        },
        "square": "",
        "color": "#1989fa",
        "plain": "",
        "icon": "play-circle",
        "type": "primary",
        "block": "",
        "size": "normal"
      }
    }, [_vm._v("开始学习")])], 1)])
  }), 0)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-e9de89ac"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileClassList.vue
// module id = 1173
// module chunks = 41